import {
  SELECTMINISITEEDITORCONTENT,
  ADDMINISITEEDITORCONTENT,
  EDITMINISITEEDITORCONTENT,
  MOVEUPMINISITEEDITORCONTENT,
  MOVEDOWNMINISITEEDITORCONTENT,
  REMOVEMINISITEEDITORCONTENT
} from "../../constants/ActionTypes";

const INIT_STATE = {
  editingComponent: false,
  addingComponent: false,
  updatingComponent: false,
  movingUpComponent: false,
  movingDownComponent: false,
  removingComponent: false
};

export default (state = INIT_STATE, action) => {

  switch (action.type) {
    case SELECTMINISITEEDITORCONTENT: {
      return {
        ...state,
        editingComponent: action.payload,
        addingComponent: false,
        updatingComponent: false,
        movingUpComponent: false,
        movingDownComponent: false,
        removingComponent: false
      }
    }

    case ADDMINISITEEDITORCONTENT: {
      return {
        ...state,
        addingComponent: action.payload,
        updatingComponent: false,
        movingUpComponent: false,
        movingDownComponent: false,
        removingComponent: false
      }
    }

    case EDITMINISITEEDITORCONTENT: {
      return {
        ...state,
        updatingComponent: action.payload,
        addingComponent: false,
        movingUpComponent: false,
        movingDownComponent: false,
        removingComponent: false
      }
    }

    case MOVEUPMINISITEEDITORCONTENT: {
      return {
        ...state,
        movingUpComponent: action.payload,
        addingComponent: false,
        updatingComponent: false,
        movingDownComponent: false,
        removingComponent: false
      }
    }

    case MOVEDOWNMINISITEEDITORCONTENT: {
      return {
        ...state,
        movingDownComponent: action.payload,
        addingComponent: false,
        updatingComponent: false,
        movingUpComponent: false,
        removingComponent: false
      }
    }

    case REMOVEMINISITEEDITORCONTENT: {
      return {
        ...state,
        removingComponent: action.payload,
        addingComponent: false,
        updatingComponent: false,
        movingUpComponent: false,
        movingDownComponent: false,
      }
    }

    default:
      return {
        ...state,
        addingComponent: false,
        updatingComponent: false,
        movingUpComponent: false,
        movingDownComponent: false,
        removingComponent: false
      }
  }
}
